module.exports = ".text-editor{\n  width: 97%;\n  margin: 1em 1em;\n  border-bottom: 1px solid rgb(200,200,200);\n  padding-bottom: 1em;\n}\n\n.form-label{\n  font-size: 1.2em;\n  font-weight: normal;\n  padding-top: 0.5em;\n}\n\n.character-counter {\n  position: relative;\n  float: right;\n  top: -31px;\n  right: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/text-editor/text-editor.component.css
// module id = ./src/app/shared/text-editor/text-editor.component.css
// module chunks = main